import { storage } from '../../utils/platform';

/**
 * Nettoie tout ce qui peut leaker entre deux comptes sur le même device :
 *  - le JWT (storage abstraction → Preferences natif ou localStorage)
 *  - tous les caches Revyo dans localStorage (insights, last sync, etc.)
 */
export async function clearAllRevyoStorage() {
  try {
    await storage.remove('token');
  } catch (e) {
    console.warn('[logout] storage.remove failed:', e?.message);
  }
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith('revyo_'))
      .forEach((k) => {
        try { localStorage.removeItem(k); } catch (_) {}
      });
  } catch (_) {}
}

export async function logoutAndRedirect(navigate) {
  await clearAllRevyoStorage();
  if (typeof navigate === 'function') navigate('/login', { replace: true });
}
